import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { render, MARK_LINK } from 'storyblok-rich-text-react-renderer';
import clsx from 'clsx';
import LinkResolver from '../../helpers/link-resolver';
import Container from '../Container';
import FancyTitle from '../fancy-title';

export default function GenericCollasibleSection({ blok, ...props }) {
  const styles = clsx(
    'blok-blogpost-faq',
  );

  const data = blok || props;

  console.log({data})

  const { title, items, marker_style: markerStyle } = data;

  const isDotMarker = markerStyle === 'dot';

  const summaryStyles = clsx(
    'generic-summary text-2xl font-bold my-4 cursor-pointer',
    isDotMarker
      ? 'list-none [&::-webkit-details-marker]:hidden marker:content-none'
      : 'marker:text-latori-green-dark',
  );

  const answerStyles = clsx(isDotMarker ? 'pl-5' : 'pl-6');

  return (
    <div {...storyblokEditable(blok)} className={styles}>
      <Container>
        <FancyTitle
          text={title}
          tag="h2"
        />
        {items?.map((faqItem, index) => (
          <details key={faqItem._uid} open={index === 0}>
            <summary className={summaryStyles}>
              {isDotMarker && (
                <span className="inline-block w-2 h-2 mr-3 rounded-full bg-[#050505] align-middle" />
              )}
              {faqItem.Question}
            </summary>
            {typeof faqItem.Answer === 'string' ? (
              <p className={answerStyles}>{faqItem.Answer}</p>
            ) : (
              render(faqItem.Answer, {
                markResolvers: {
                  [MARK_LINK]: LinkResolver,
                },
              })
            )}
          </details>
        ))}
      </Container>
    </div>
  );
}
